export var sampleData = {
    mockArticleHero: {
        title: "Ways to reduce individual stock concentration",
        color: "#fdb516",
    },
};
